import { createApp } from 'vue'
import StepContainer from './components/stepContainer.vue'
import FButtonAddToCart from '~/js/components/buttonAddToCart'
import { STEPS } from './constants'
import { ItemAddToCart } from '~/js/components/buttonAddToCart/index.vue'

const ID_PAGE_CUSTOM_PRODUCTS = 'js-page-custom-products'

document.addEventListener('DOMContentLoaded', async () => {
  const elementPageCustomProducts = document.getElementById(
    ID_PAGE_CUSTOM_PRODUCTS
  )
  if (!elementPageCustomProducts) return

  const productsString = elementPageCustomProducts.dataset.products
  const products = productsString ? JSON.parse(productsString) : []

  createApp({
    name: 'TemplatesPageCustomProducts',
    components: { StepContainer, FButtonAddToCart },
    data() {
      return {
        currentStep: null,
        selectedProducts: new Array(STEPS.length).fill(''),
        showCompletedImage: false,
      }
    },
    computed: {
      completedImageUrl() {
        const filename = this.selectedProducts
          .filter((_, index) => STEPS[index].includeCompletedImage)
          .map((product) => product.sku)
          .join('_')
        return `//cdn.shopify.com/s/files/1/0132/7936/3136/files/${filename}.jpg`
      },
      isStepsComplete() {
        return this.selectedProducts.every((product) => !!product)
      },
      itemsAddToCart() {
        return this.selectedProducts.map((product) => {
          return new ItemAddToCart({
            ...product,
            handle: product.sku,
          })
        })
      },
      steps() {
        return STEPS.map((step, index) => {
          return {
            ...step,
            products: products[index],
          }
        })
      },
    },
    mounted() {
      this.$el.parentElement.style.display = null
    },
    methods: {
      onShowCompletedImageClicked() {
        this.showCompletedImage = true
        this.$nextTick(() => {
          this.scrollTo()
        })
      },
      onProductSelected(index, product) {
        this.showCompletedImage = false
        this.selectedProducts[index] = product
        this.currentStep = index + 1
        // eslint-disable-next-line no-extra-boolean-cast
        while (!!this.selectedProducts[this.currentStep]) {
          this.currentStep++
        }
        if (this.currentStep >= STEPS.length) this.currentStep = null
        this.$nextTick(() => {
          this.scrollTo()
        })
      },
      onStepClicked(index) {
        this.currentStep = index
        this.$nextTick(() => {
          this.scrollTo()
        })
      },
      scrollTo() {
        const targetRef = Number.isInteger(this.currentStep)
          ? `step${this.currentStep}`
          : 'completed-area'
        const elementsTarget = this.$refs[targetRef]
        const elementTarget = elementsTarget.length
          ? elementsTarget[0]
          : elementsTarget
        elementTarget.scrollIntoView({
          behavior: 'smooth',
        })
      },
    },
  }).mount(elementPageCustomProducts)
})
